module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970-desktop/0067.jpg?v=dc83b0ea";